import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components //
const Root = styled.div`
  margin-top: 16px;
  overflow: auto;
  height: 240px;
  width: 100%;
`;

const Code = styled.code`
  font-family: 'Realtime', monospace;
  font-size: 13px;
`;

const Response = ({ json }) => {
  const jsonStr = JSON.stringify(json, null, 2);
  return (
    <Root>
      <pre>
        <Code>
          { jsonStr }
        </Code>
      </pre>
    </Root>
  );
}

Response.propTypes = {
  json: PropTypes.string.isRequired,
};

export default Response;
